import React from 'react';
import styled, { useTheme } from 'styled-components';

import Footer from '../containers/Footer';
import { Link } from 'react-router-dom';
import Lottie from 'lottie-react';
import timeout from '../assets/timeout.json';
import { clearLocalStorage } from '../utils/utils';

const Wrapper = styled.div`
  height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 36px;
  padding-bottom: 100px;
`;

const WaitImage = styled.img`
  width: 70%;
  height: auto;
  max-width: 300px;
`;

const MainText = styled.div`
  margin: 30px 0 20px 0;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.basic2000};
`;

const Subtext = styled.h4`
  font-size: 18px;
  line-height: 26px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.basic2000};
  margin: 0 0 40px 0;
  text-align: center;
  width: 80%;

  @media (orientation: portrait) and (max-width: 767px) {
    width: 100%;
  }
`;

const ExtraText = styled.h5`
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.basic2000};
  margin: 30px 0 0 0;
  text-align: center;
`;

const ButtonWrapper = styled.div`
  width: 70%;
  margin-top: 20px;

  @media (orientation: portrait) and (max-width: 767px) {
    width: 100%;
  }
`;


const Expired = () => {
  const theme = useTheme();
  clearLocalStorage();

  return (
    <Wrapper>
      <Lottie animationData={timeout} style={{ width: '200px', margin: '40px 0 0 0' }}/>
      <MainText>
        Sesión expirada
      </MainText>
      <Subtext>
        Tu sesión ha expirado debido a un período prolongado de inactividad.
      </Subtext>
      <ExtraText>
        Por motivos de seguridad, necesitamos que vuelvas a comenzar el proceso.
        <br />
        No te preocupes, tus datos anteriores se han eliminado de forma segura.
      </ExtraText>
      <ButtonWrapper>
        <div className='flex justify-center'>
          <Link to={`/`}>
            <button className='bg-[#fff200] text-black p-2 rounded w-96 py-5 rounded-lg font-bold text-xl'>
              Volver a comenzar
            </button>
          </Link>
        </div>
      </ButtonWrapper>
      {/* <Footer /> */}
    </Wrapper>
  )
};

export default Expired;
